class PaperJournalToggle {
    constructor(element) {
        element.addEventListener("click", this.onClick.bind(this));
        this.element = element;
        this.target = document.querySelector(`${element.dataset.target}`);
        // document.getElementById("showmore-paperjournal").addEventListener("click", this.onClick.bind(this));
        this.init();       
    }

    init() {
        


        // var numberOfCards = document.getElementsByClassName("paperjournalblock__box").length;   
        // var showMoreButton = document.getElementById("show-more-button");
        // var cards = document.querySelectorAll("paperjournalblock__box");
       
        // if (numberOfCards >= 5) {
        //     showMoreButton.classList.remove("hide-button");    
            
        //     cards.forEach((card) => {
        //         card.classList.add("testclass");
        //         console.log("test");
        //     })
            
        // } else {
        //     showMoreButton.classList.add("hide-button");
        // }

        // console.log(numberOfCards);

        // var mobileCards = document.getElementsByClassName("test");
       
        // if (mobileCards) {
        //     console.log("testttt");   
        // }

        // cards.forEach((card) => {
        //     console.log("can you work")
        //     card.classList.add("wut");
        // })
    }

    onClick() {
        console.log("click test");
       
        var paperJournalBoxes = document.querySelectorAll(".paperjournalblock__row");

    
        paperJournalBoxes.forEach((paperJournalBox) => {
          console.log(paperJournalBox);
          paperJournalBox.classList.toggle("paperjournalblock__five-items");
        });
    }
}

export default PaperJournalToggle;